
import { getUnreadCount } from './functions';
import { NOTIFICATION_TIMEOUT, showNotification } from '../notifications';
import { ADD_MESSAGE } from './actionTypes';

declare var APP: Object;
declare var interfaceConfig : Object;

export async function RPC_ChatMiddleware(store, next, action) {
    const { dispatch, getState } = store;
    let isOpen, unreadCount;

    switch (action.type) {
        case ADD_MESSAGE:
            unreadCount = action.hasRead ? 0 : getUnreadCount(getState()) + 1;
            isOpen = getState()['features/chat'].isOpen;

            if(!isOpen && (Date.now() - action.timestamp) < 3000) {
                dispatch(showNotification({
                    titleKey: 'notify.name',
                    title: action.displayName,
                    description: action.message
                }, NOTIFICATION_TIMEOUT));
            }

            break;
    }

    return next(action);
}